import React, { useState, useEffect } from 'react';
import {
  VStack, Input, Select, Textarea, Text, Box, Button,
  useToast, SimpleGrid, InputGroup, InputRightElement
} from '@chakra-ui/react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { GOOGLE_MAPS_API_KEY } from 'config/googleMaps';
import AxiosInstance from '../../../api/AxiosInstance';

type Modo = 'new' | 'edit' | 'view';

interface Props {
  modo: Modo;
  data?: any;
  onSubmit?: (data: any) => void;
}

const tiposDesarrollo = ['Habitacional', 'Comercial', 'Industrial'];

const SolicitudUrbanizacion: React.FC<Props> = ({ modo, data, onSubmit }) => {
//PERFIL CONSULTA
  const [perfiles, setPerfiles] = useState<any[]>([]);
const [curpSeleccionado, setCurpSeleccionado] = useState('');
const [nombreCompleto, setNombreCompleto] = useState('');
const [curp, setCurp] = useState('');
const [direccionPerfil, setDireccionPerfil] = useState('');
//PERFIL TERMINA CONSULTA



  const toast = useToast();

  const [tipoDesarrollo, setTipoDesarrollo] = useState(data?.tipoDesarrollo || '');
  const [area, setArea] = useState(data?.area || '');
  const [costo, setCosto] = useState(data?.costo || 0);
  const [direccion, setDireccion] = useState(data?.direccion || '');
  const [lat, setLat] = useState(Number(data?.lat) || 19.4326);
  const [lng, setLng] = useState(Number(data?.lng) || -99.1332);
  const [observaciones, setObservaciones] = useState(data?.observaciones || '');
const [tiempoRespuesta, setTiempoRespuesta] = useState(data?.tiempoRespuesta || '');

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  //perfil request api
  useEffect(() => {
    AxiosInstance.get('/usuario/perfil')
      .then((res) => setPerfiles(res.data))
      .catch(() => setPerfiles([]));
  }, []);
  //perfil request termina
  

  useEffect(() => {
    const tarifa = 120; // dummy
    setCosto(area * tarifa);
  }, [area]);

  const buscarDireccion = () => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: direccion }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const loc = results[0].geometry.location;
        setLat(loc.lat());
        setLng(loc.lng());
        setDireccion(results[0].formatted_address);
      } else {
        toast({
          title: 'Dirección no encontrada',
          description: 'Revisa la dirección ingresada.',
          status: 'error',
        });
      }
    });
  };

  const handleGuardar = async () => {
    const payload = {
      tipoDesarrollo,
      area,
      costo,
      direccion,
      lat,
      lng,
      observaciones,
      fechaRegistro: new Date(),
        tiempoRespuesta, 
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-urbanizacion`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error('Error al registrar');

      toast({
        title: 'Éxito',
        description: 'Solicitud registrada correctamente.',
        status: 'success',
      });

      onSubmit?.(payload);
    } catch (err) {
      toast({
        title: 'Error',
        description: 'No se pudo registrar la solicitud.',
        status: 'error',
      });
    }
  };

  if (!isLoaded) return <Text>Cargando mapa...</Text>;

  return (
    <VStack spacing={4} align="stretch">
      {(modo === 'edit' || modo === 'new') ? (
        <>

{/* PERFIL USUARIO */}
<SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={4}>

{/* <Select placeholder="Buscar por CURP" value={curpSeleccionado} onChange={(e) => {
  const val = e.target.value;
  setCurpSeleccionado(val);
  const perfil = perfiles.find(p => p.curp === val);
  if (perfil) {
    setNombreCompleto(`${perfil.nombre} ${perfil.primerApellido || ''} ${perfil.segundoApellido || ''}`);
    setCurp(perfil.curp || '');
    setDireccionPerfil(perfil.direccion || '');
  }
}}>
  <option value="">Seleccionar CURP</option>
  {perfiles.map((p) => (
    <option key={p.id} value={p.curp}>{p.curp}</option>
  ))}
</Select> */}
<Text><strong>Tiempo de respuesta estimado:</strong> {tiempoRespuesta}</Text>

 <Input
      value={nombreCompleto}
      placeholder="Nombre completo"
      onChange={(e) => setNombreCompleto(e.target.value)}
    />
    
    <Input
        value={curp}
        placeholder="CURP"
        onChange={(e) => setCurp(e.target.value)}
      />

      <Input
        value={direccionPerfil}
        placeholder="Dirección del perfil"
        onChange={(e) => setDireccionPerfil(e.target.value)}
      />

      <Input
  placeholder="Tiempo estimado de respuesta (ej. 5 días)"
  value={tiempoRespuesta}
  onChange={(e) => setTiempoRespuesta(e.target.value)}
/>

</SimpleGrid>
{/* PERFIL USUARIO */}


                <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={4}>
        
          <Select placeholder="Tipo de desarrollo" value={tipoDesarrollo} onChange={(e) => setTipoDesarrollo(e.target.value)}>
            {tiposDesarrollo.map((t) => <option key={t} value={t}>{t}</option>)}
          </Select>
        
          <Input type="number" placeholder="Área (m²)" value={area} onChange={(e) => setArea(parseFloat(e.target.value))} />
          </SimpleGrid>
          <Text><strong>Costo estimado:</strong> ${costo.toFixed(2)}</Text>

          <InputGroup>
            <Input placeholder="Dirección" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
            <InputRightElement width="4.5rem">
              <Button h="1.75rem" size="sm" onClick={buscarDireccion}>Buscar</Button>
            </InputRightElement>
          </InputGroup>

          <Box h="200px" w="100%">
            <GoogleMap zoom={15} center={{ lat, lng }} mapContainerStyle={{ width: '100%', height: '100%' }}>
              <Marker
                position={{ lat, lng }}
                draggable
                onDragEnd={(e) => {
                  setLat(e.latLng?.lat() || lat);
                  setLng(e.latLng?.lng() || lng);
                }}
              />
            </GoogleMap>
          </Box>

          <Textarea placeholder="Observaciones" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />

          <Button colorScheme="green" onClick={handleGuardar}>
            {modo === 'new' ? 'Registrar' : 'Actualizar'}
          </Button>
        </>
      ) : (
        <>
          <SimpleGrid columns={2} spacing={4}>

            
            <Box>
              <Text><strong>Tipo desarrollo:</strong> {tipoDesarrollo}</Text>
              <Text><strong>Área:</strong> {area} m²</Text>
              <Text><strong>Costo:</strong> ${costo}</Text>
              <Text><strong>Dirección:</strong> {direccion}</Text>
            </Box>
            <Box>
              {observaciones && <Text><strong>Observaciones:</strong> {observaciones}</Text>}
            </Box>
          </SimpleGrid>
          <Box h="200px" w="100%">
            <GoogleMap zoom={15} center={{ lat, lng }} mapContainerStyle={{ width: '100%', height: '100%' }}>
              <Marker position={{ lat, lng }} />
            </GoogleMap>
          </Box>
        </>
      )}
    </VStack>
  );
};

export default SolicitudUrbanizacion;
